<script>
import menuMixins from './menuMixins'
import ICON_THEME from '../../assets/img/theme.svg'
import ICON_THEME1 from '../../assets/img/theme_active.svg'
import ICON_SETTING from '../../assets/img/setting.svg'
import ICON_SETTING1 from '../../assets/img/setting_active.svg'

export default {
    mixins: [menuMixins],
    render() {
        const {
            defaultActive, baseRoute, $route, isTenant,
        } = this
        return (
            <hc-menu
                default-active={defaultActive}
                class="app-menu app-menu--setting"
                router
                collapse
            >
                <hc-menu-item index={`${baseRoute}/theme`}>
                    {
                        $route.fullPath === `${baseRoute}/theme` ? <img src={ICON_THEME1} alt="" /> : <img src={ICON_THEME} alt="icon" />
                    }
                    <span slot="title">主题风格</span>
                </hc-menu-item>
                {
                    <hc-submenu index="2">
                        <template slot="title">
                            {
                                [`${baseRoute}/role`, `${baseRoute}/components`, `${baseRoute}/setting`].includes($route.fullPath) ? <img src={ICON_SETTING1} alt="" /> : <img src={ICON_SETTING} alt="icon" />
                            }
                        </template>
                        { !isTenant && <hc-menu-item index={`${baseRoute}/role`}>角色与权限</hc-menu-item> }
                        {<hc-menu-item index={`${baseRoute}/components`}>组件库</hc-menu-item> }
                        <hc-menu-item index={`${baseRoute}/setting`}>设置</hc-menu-item>
                    </hc-submenu>
                }

            </hc-menu>
        )
    },
}
</script>

<style lang="less" scoped>
@import './common.less';
.app-menu--setting{
    margin-bottom: 36px;
}
</style>
